"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var storage = {
  load: function load(key) {
    try {
      var serializedState = localStorage.getItem(key);

      if (serializedState === null) {
        return null;
      }

      return JSON.parse(serializedState);
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  save: function save(key, value) {
    try {
      var serializedState = JSON.stringify(value);
      localStorage.setItem(key, serializedState);
    } catch (err) {
      console.error(err);
    }
  },
  clear: function clear(key) {
    localStorage.removeItem(key);
  }
};

var LocalStorageEntity =
/** @class */
function () {
  function LocalStorageEntity(key) {
    this.key = key;
  }

  LocalStorageEntity.prototype.save = function (value) {
    return storage.save(this.key, value);
  };

  LocalStorageEntity.prototype.load = function () {
    return storage.load(this.key);
  };

  LocalStorageEntity.prototype.clear = function () {
    storage.clear(this.key);
  };

  return LocalStorageEntity;
}();

exports.LocalStorageEntity = LocalStorageEntity;